/* eslint-disable max-lines */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-return-assign */
// TODO: remove eslint-disable lines during code cleanup/file refactor
import React, { Component } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GoogleMap, LoadScript, Marker, MarkerClusterer } from '@react-google-maps/api';
import SimpleBarReact from 'simplebar-react';

import MarkerPremium from 'assets/images/ab-map.png';
import ClusterPremium from 'assets/images/ab-mapCluster.png';
import ClusterFree from 'assets/images/ab-mapClusterGrey.png';
import MarkerFree from 'assets/images/ab-mapGrey.png';

import BackButton from 'components/BackButton';
import FreeHotel from 'components/FreeHotel';
import PremiumHotel from 'components/PremiumHotel';

import APIHandler from 'config/APIHandler';

import 'simplebar/src/simplebar.css';


let containerStyle = {
  width: '100%',
  height: 'calc(100vh - 10rem)',
};

const params = new URLSearchParams(window.location.search);
if (params.get('header')) {
  containerStyle = {
    width: '100%',
    height: '100vh',
  };
}

const clusterPremium = {
  styles: [
    {
      url: ClusterPremium,
      width: 35,
      height: 51,
      textColor: 'white',
      textSize: 14,
      fontFamily: 'Source Sans Pro',
    },
  ],
  clusterClass: 'clusterIcon',
};

const clusterFree = {
  styles: [
    {
      url: ClusterFree,
      width: 35,
      height: 51,
      textColor: 'white',
      textSize: 14,
      fontFamily: 'Source Sans Pro',
    },
  ],
  clusterClass: 'clusterIcon',
};

export default class DirectoryView extends Component {
  static closeIframe() {
    document.getElementById('iframe').classList.add('hide');
  }
  
  constructor(props) {
    super(props);

    this.state = {
      premiumHotelsList: [],
      freeHotelsList: [],
      lat1: 89.8024135685952,
      lat2: -88.78515361758781,
      lon1: 170.35526546875,
      lon2: -163.76094546875,
      query: '',
      zoom: 4,
      header: false,
      center: {
        lat: 37.09024,
        lng: -95.712891,
      },
      color: '405866',
      font: 'Source Sans Pro',
      userInfo: '',
      mobile: false,
    };
  }

  componentDidMount() {
    // const params = new URLSearchParams(window.location.search);
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    const mobile = false;
    let header = false;
    if (params.get('header')) {
      header = true;
    }

    this.getHotelsList();

    // eslint-disable-next-line react/no-unused-state
    this.setState({ mobile, width, header });
  }

  handleInputChange = () => {
    this.setState(
      {
        query: this.search.value,
      },
      this.getHotelsList(),
    );
  };

  getHotelsList() {
    setTimeout(() => {
      const { lat1, lat2, lon1, lon2, query } = this.state;
      APIHandler.getFreeHotelsList(lat1, lat2, lon1, lon2, query).then((results) => {
        this.setState({ freeHotelsList: results });
      });
    }, 200);

    // APIHandler.getPremiumHotelsList(lat1, lat2, lon1, lon2).then((results) => {
    //   this.setState({ premiumHotelsList: results.items });
    // });
  }

  flyToMarker = (lat, lon) => {
    this.setState({
      zoom: 15,
      center: {
        lat: Number(lat),
        lng: Number(lon),
      },
    });
  };

  premiumInfo = (userInfoID) => {
    document.getElementById('iframe').classList.remove('hide');
    this.setState({
      userInfo: `https://travproconnect.com/profile/${userInfoID}?app_id=1441`,
    });
  };

  freeInfo = (userInfoID) => {
    const { mobile, color, font } = this.state;
    const messageUrlRoot = 'https://travpro.yourworldapps.nl/profile-web.php';
    if (mobile) {
      window.postMessage(
        `${messageUrlRoot}?app_id=633&rooms=no&id=${userInfoID}&color=${color}&font=${font}&zoom=10`,
        '*',
      );
    } else {
      document.getElementById('iframe').classList.remove('hide');
      this.setState({
        userInfo: `${messageUrlRoot}?app_id=633&rooms=no&id=${userInfoID}&color=${color}&font=${font}&zoom=10`,
      });
    }
  };

  loadProperties(bounds, zoom) {
    this.setState({
      lat1: bounds.getNorthEast().lat(),
      lat2: bounds.getSouthWest().lat(),
      lon1: bounds.getNorthEast().lng(),
      lon2: bounds.getSouthWest().lng(),
      zoom,
    });
    this.getHotelsList();
  }

  render() {
    const { premiumHotelsList, freeHotelsList, zoom, center, userInfo, mobile, header } = this.state;

    return (
      <div className="directoryContainerNew">
        {!header && (
          <div className="header">
            <BackButton useHistory={false} text="Back" />
          </div>
        )}
        <div className="directoryViewNew">
          <div className="leftSide">
            <div className="results">
              {'Amount of results: '}
              {freeHotelsList.length + premiumHotelsList.length}
            </div>
            <SimpleBarReact className="listContainer">
              <div className="search">
                <FontAwesomeIcon icon={['fas', 'search']} className="searchIcon" />
                <input
                  className="searchInput"
                  placeholder="Search an advisor..."
                  type="text"
                  ref={(input) => (this.search = input)}
                  onChange={this.handleInputChange}
                />
              </div>
              <div className="filter">
                {'FILTER BY TYPE:'}
                <div className="filter__Buttons">
                  <a className="filter__Button selected">
                    <span>{'Receptive'}</span>
                  </a>
                  <a className="filter__Button">
                    <span>{'Showcase'}</span>
                  </a>
                </div>
                <div className="line" />
              </div>
              <div className="premiumList">
                {premiumHotelsList.length > 0 &&
                  premiumHotelsList.map((hotel) => (
                    <PremiumHotel
                      key={hotel.id}
                      id={hotel.id}
                      bgImage={hotel.headerImages[0]}
                      propertyName={hotel.propertyName}
                      flyToMarker={() => {
                        this.flyToMarker(hotel.coords.latitude, hotel.coords.longitude);
                      }}
                      hotelInfo={() => {
                        this.premiumInfo(hotel.userInfoID);
                      }}
                    />
                  ))}
              </div>
              {header && (
                <style>
                  {
                    '\
              .directoryContainer { height: 100vh; } .listContainer { height: calc(100vh - 8rem) !important; }'
                  }
                </style>
              )}
              <div className="freeList">
                {freeHotelsList.length > 0 &&
                  freeHotelsList.map((hotel) => (
                    <FreeHotel
                      key={hotel.company_listing_id}
                      id={hotel.company_listing_id}
                      bgImage={hotel.img_path}
                      flyToMarker={() => {
                        this.flyToMarker(hotel.latitude, hotel.longitude);
                      }}
                      hotelInfo={() => {
                        this.freeInfo(hotel.listing_id);
                      }}
                      hotelName={hotel.company}
                      location={hotel.city}
                      phoneNumber={hotel.phone}
                      address={hotel.addr1}
                      category={hotel.category}
                      other={hotel}
                    />
                  ))}
              </div>
            </SimpleBarReact>
          </div>
          <div className="rightSide">
            {!mobile && (
              <LoadScript googleMapsApiKey="AIzaSyBpfyrBMTrgHH3YnaGHxfjEN_w7OXBJoqc">
                <GoogleMap
                  mapContainerStyle={containerStyle}
                  center={center}
                  zoom={zoom}
                  onLoad={(map) => {
                    this.map = map;
                  }}
                  onIdle={() => {
                    this.loadProperties(this.map.getBounds(), this.map.getZoom());
                  }}
                >
                  {/* Child components, such as markers, info windows, etc. */}
                  <MarkerClusterer minimumClusterSize={2} gridSize={100} options={clusterFree}>
                    {(clusterer) =>
                      freeHotelsList.length > 0 &&
                      freeHotelsList.map((freeHotel) => (
                        <Marker
                          key={freeHotel.listing_id}
                          position={{
                            lat: Number(freeHotel.latitude),
                            lng: Number(freeHotel.longitude),
                          }}
                          icon={MarkerFree}
                          onClick={() => {
                            this.flyToMarker(freeHotel.latitude, freeHotel.longitude);
                          }}
                          clusterer={clusterer}
                        />
                      ))
                    }
                  </MarkerClusterer>
                  <MarkerClusterer minimumClusterSize={5} options={clusterPremium}>
                    {(clusterer) =>
                      premiumHotelsList.length > 0 &&
                      premiumHotelsList.map((premiumHotel) => (
                        <Marker
                          key={premiumHotel.id}
                          position={{
                            lat: premiumHotel.coords.latitude,
                            lng: premiumHotel.coords.longitude,
                          }}
                          icon={MarkerPremium}
                          onClick={() => {
                            this.flyToMarker(premiumHotel.coords.latitude, premiumHotel.coords.longitude);
                          }}
                          clusterer={clusterer}
                        />
                      ))
                    }
                  </MarkerClusterer>
                </GoogleMap>
              </LoadScript>
            )}
          </div>

          <div className="iframe hide" id="iframe">
            <div
              className="bgIframe"
              onClick={() => {
                this.closeIframe();
              }}
            />
            <div className="iframeHolder">
              <div
                className="closeIframe"
                href="#"
                onClick={() => {
                  this.closeIframe();
                }}
              >
                <span className="closeText">
                  <FontAwesomeIcon icon={['fas', 'chevron-left']} /> {'Back'}
                </span>
              </div>
              <div className="contentIframe">
                <iframe width="100%" height="100%" id="iframeModal" src={userInfo} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
